/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationRelationLinkChild } from '../../axios/organisationRelationLinkChild'
import type {
	OrganisationRelationLinkChildError,
	OrganisationRelationLinkChildPathParams,
	OrganisationRelationLinkChildRequest,
	OrganisationRelationLinkChildResponse,
} from '../../types/OrganisationRelationLinkChild'

export const organisationRelationLinkChildMutationKey = () =>
	[{ url: '/organisations/:organisation/children' }] as const

export type OrganisationRelationLinkChildMutationKey = ReturnType<typeof organisationRelationLinkChildMutationKey>

export type OrganisationRelationLinkChildVariables = {
	organisation: OrganisationRelationLinkChildPathParams['organisation']
	data: OrganisationRelationLinkChildRequest
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationRelationController.php OrganisationRelationController::linkChild */
export function useOrganisationRelationLinkChild<TContext = unknown>(
	options?: UseMutationOptions<
		OrganisationRelationLinkChildResponse,
		AxiosError<OrganisationRelationLinkChildError>,
		OrganisationRelationLinkChildVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: organisationRelationLinkChildMutationKey(),
		mutationFn: ({ organisation, data }: OrganisationRelationLinkChildVariables) =>
			organisationRelationLinkChild(organisation, data, config).then(res => res.data),
		...options,
	})
}
